import { Serializer, UISerializableOrderActionRecord } from '@drift/common';
import { getPredictionsHistoryFilter } from 'src/utils/historyTables';
import { useComposedHistory } from './useComposedHistory';
import type { HistoryTableUIProps } from './historyDataTypes';

export const usePredictionTradesHistory =
	(): HistoryTableUIProps<UISerializableOrderActionRecord> => {
		const { historyData, executePageChange } = useComposedHistory(
			'predictionTrades',
			Serializer.Deserialize.DataApiUIOrderActionRecord
		);

		return {
			executePageChange,
			filterFn: getPredictionsHistoryFilter,
			historyData,
		};
	};
